import { useScopeContext } from '../context/ScopeProvider';

export function useScope() {
  const { activeScope, availableScopes, setActiveScope, invalidateScope } = useScopeContext();

  return {
    activeScope,
    availableScopes,
    setActiveScope,
    invalidateScope,
    hasScope: activeScope !== null,
    getScopePath: () => {
      if (!activeScope) return '';
      const parts = [
        activeScope.tenantId,
        activeScope.operatingGroupId,
        activeScope.operatingEntityId,
        activeScope.facilityId,
        activeScope.subZoneId
      ].filter(Boolean);
      return parts.join(' > ');
    }
  };
}

export function useScopeSwitcher() {
  const { activeScope, availableScopes, setActiveScope } = useScopeContext();

  const switchScope = (scopeId: string) => {
    const targetScope = availableScopes.find(s => s.facilityId === scopeId);
    if (targetScope) {
      setActiveScope(targetScope);
    }
  };

  return {
    activeScope,
    availableScopes,
    switchScope,
    setActiveScope
  };
}
